
import { FC } from "react";
import { AuthenticatedLayout } from "../../../layouts";
import { RL1SlipList } from "../../../components/RL1Slip";

export interface IRL1SlipListPage {}

export const RL1SlipListPage: FC<IRL1SlipListPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="RL-1 Slip List"
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Compliance", navigateTo: "/compliance/rl1/list" },
        // { text: "RL-1", navigateTo: "/compliance/rl1/list" },
        // { text: "RL-1 Slips", navigateTo: "/compliance/rl1/list" },
      ]}
      mainContents={<RL1SlipList />}
    />
  );
};
